import React from "react";
import { Card, Form, Switch, Typography, theme } from "antd";
import { SyncOutlined } from "@ant-design/icons";

interface Props {
  form: any;
  isEditing: boolean;
}

const SyncSettingsForm: React.FC<Props> = ({ form, isEditing }) => {
  const { token } = theme.useToken();

  return (
    <Card
      title={
        <span>
          <SyncOutlined style={{ color: token.colorPrimary }} />
          <span style={{ marginLeft: 8 }}>Sync Settings</span>
        </span>
      }
      size="small"
      style={{ marginTop: 16, borderRadius: 8 }}
    >
      <Form form={form} layout="vertical" disabled={!isEditing}>
        <Form.Item
          name="isSyncEnabled"
          label="Enable Employee Sync"
          valuePropName="checked"
        >
          <Switch checkedChildren="On" unCheckedChildren="Off" />
        </Form.Item>
        <Typography.Text type="secondary">
          Toggle to enable or disable external sync for this employee.
        </Typography.Text>
      </Form>
    </Card>
  );
};

export default SyncSettingsForm;
